import segment from './segment';

export function getAnalytics() {
  return segment;
}
